import { useTranslation } from "react-i18next";

import { Button } from "@digital-services/ui";

import { OrganizationStatus } from "@organization/models/OrganizationDetails";

export const DeactivateOrganizationButton = props => {
  const { status, disableEditOrganization, onClick } = props;

  const { t } = useTranslation(undefined, { keyPrefix: "organization" });

  return (
    <Button
      className="select-none"
      disabled={disableEditOrganization}
      variant={status === OrganizationStatus.InActive ? "primary" : "ghost"}
      onClick={onClick}
      data-testid="status"
    >
      {status === OrganizationStatus.InActive
        ? t("status.activate.label")
        : t("status.deactivate.label")}
    </Button>
  );
};
